import { render } from "./TeamMembers.vue?vue&type=template&id=4f782b03&scoped=true"
import script from "../js/team-members.js?vue&type=script&lang=js"
export * from "../js/team-members.js?vue&type=script&lang=js"

import "./TeamMembers.vue?vue&type=style&index=0&id=4f782b03&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f782b03"]])

export default __exports__